import React, { useState, useCallback, useEffect, useRef } from 'react';
import '../ViewTemplateSection/ViewTemplateTable.scss'

//FontAwesome icons
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface CellProps {
    value: string;
    rowIndex: number;
    columnKey: string;
    onChange: (rowIndex: number, columnKey: string, value: string) => void;
    isHeader: boolean;
    isRowNumber: boolean;
    hasError: boolean;
    rowHasError: boolean;
    mouseoverText: string;
    isEditing?: boolean;
    onDeleteRow: (rowIndex: number) => void;
}

const Cell: React.FC<CellProps> = React.memo(({ value, rowIndex, columnKey, onChange, isHeader, isRowNumber, hasError, rowHasError, mouseoverText, isEditing, onDeleteRow }) => {

    // Using React-Window for performance optimization in order to display the templates correctly is buggy when using a <table> or inputs
    // Therefore we have torefocus the curson and use <div>s insteads of table elements.
    const inputRef = useRef<HTMLInputElement>(null);

    const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(rowIndex, columnKey, event.target.value);
    }, [onChange, rowIndex, columnKey]);


    useEffect(() => {
        if (
            isEditing &&
            inputRef.current &&
            document.activeElement !== inputRef.current &&
            inputRef.current !== document.activeElement
        ) {
            // Only focus if it's not already focused
            inputRef.current.focus();

            const length = inputRef.current.value.length ?? 0;
            inputRef.current.setSelectionRange(length, length);
        }
    }, [isEditing]);


    return (
        <div
            data-row={rowIndex + 2}
            data-column={columnKey}
            title={mouseoverText ? mouseoverText : undefined}
            className={[
                columnKey === "RowNumber" ? "rowNumberCell" : "",
                isHeader ? "headerCell" : "",
                hasError ? "hasError" : "validCell",
                rowHasError ? "rowHasError" : "",
                !isHeader && !hasError && rowIndex % 2 != 0 ? "zebraRow" : ""
            ].filter(Boolean).join(" ")}
        >
            {isHeader ? (
                    <div>{value}</div>
            ) : isRowNumber ? (
                    <div className = "rowNumberCellContent">
                        { value }  
                        <button
                            className="deleteRowButton"
                            onClick={() => onDeleteRow(rowIndex)}
                            title="Delete this row"
                        >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                    </div> 
            ) : (
                    <input
                        ref={inputRef}
                        type="text"
                        value={value}
                            onChange={handleInputChange}
                            style={{ width: "90%", padding: "2px", margin: "auto" }}
                    />
            )}
        </div>
    );
},
    (prevProps, nextProps) =>
        prevProps.value === nextProps.value &&
        prevProps.hasError === nextProps.hasError &&
        prevProps.mouseoverText === nextProps.mouseoverText &&
        prevProps.isHeader === nextProps.isHeader
);

export default Cell;
